import React, { useState } from "react";
import "./infoicon.css";

const InfoIcon = ({text}) => {
  const [hover, setHover] = useState(false);

  return (
    <div className="container">
      <img
        className="img"
        src="/images/info.svg"
        alt="info"
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      />
      {hover ? (
        <div className="text-container">
          {text}
        </div>
      ) : null}
    </div>
  );
};

export default InfoIcon;
